import { BUILD_TRAY_OPEN, TRAY_ALERT_OPEN, BUILD_TRAY_BUTTON_REF } from '@instructure/quiz-common';
import { connect } from '../../../../common/react-redux';
import { set as setUI, clear, newActiveBank, newActiveBankEntry } from '../../../../common/actions/ui';
import { BanksTray as BanksTrayPresenter } from './presenter';
function mapStateToProps(state) {
  return {
    activeBankId: state.getIn(['ui', 'activeBankId']),
    activeBankEntryId: state.getIn(['ui', 'activeBankEntryId']),
    trayOpen: !!state.getIn(['ui', BUILD_TRAY_OPEN]),
    trayAlertOpen: !!state.getIn(['ui', TRAY_ALERT_OPEN]),
    trayTrigger: state.getIn(['ui', BUILD_TRAY_BUTTON_REF])
  };
}
export var BanksTray = connect(mapStateToProps, {
  newActiveBankEntry: newActiveBankEntry,
  newActiveBank: newActiveBank,
  clear: clear,
  setUI: setUI
})(BanksTrayPresenter);
export default BanksTray;